import {produce} from 'immer'
import type {StateCreator} from 'zustand'

export interface FilesCollapsedStatusSliceOpts {
  collapsedFilesMap: Record<string, boolean>
}

export type FilesCollapsedStatusSlice = {
  collapsedFilesMap: Record<string, boolean>

  filesCollapsedStatusActions: {
    updateFileCollapsedStatus: (filePath: string, collapsedStatus: boolean) => void
    updateAllFilesCollapsedStatus: (collapsedStatus: boolean) => void
  }
}

export const createFilesCollapsedStatusSlice =
  ({
    collapsedFilesMap,
  }: FilesCollapsedStatusSliceOpts): StateCreator<
    FilesCollapsedStatusSlice,
    [['zustand/devtools', never]],
    [],
    FilesCollapsedStatusSlice
  > =>
  (set, get) => ({
    collapsedFilesMap,

    filesCollapsedStatusActions: {
      updateFileCollapsedStatus: (filePath, collapsedStatus) => {
        const oldCollapsedMap = get().collapsedFilesMap
        if (!oldCollapsedMap) {
          return
        }

        set(
          {
            collapsedFilesMap: produce(oldCollapsedMap, (m: Record<string, boolean>) => {
              m[filePath] = collapsedStatus
            }),
          },
          undefined,
          'updateFileCollapsedStatus',
        )
      },
      updateAllFilesCollapsedStatus: collapsedStatus => {
        const oldCollapsedMap = get().collapsedFilesMap
        if (!oldCollapsedMap) {
          return
        }
        set(
          {
            collapsedFilesMap: produce(oldCollapsedMap, (m: Record<string, boolean>) => {
              for (const filePath of Object.keys(m)) {
                m[filePath] = collapsedStatus
              }
            }),
          },
          undefined,
          'deleteThreadComment',
        )
      },
    },
  })
